/** Статьи наших трат по-русски: список трат, фильтр и дашборд админки. */
export const INTERNAL_EXPENSE_CATEGORY_OPTIONS = [
  { label: "Инфраструктура", value: "INFRASTRUCTURE" },
  { label: "Софт и подписки", value: "SOFTWARE" },
  { label: "Подрядчики", value: "CONTRACTORS" },
  { label: "Маркетинг", value: "MARKETING" },
  { label: "Юридические услуги", value: "LEGAL" },
  { label: "Налоги и сборы", value: "TAXES" },
  { label: "Другое", value: "OTHER" },
] as const;

export const INTERNAL_EXPENSE_CATEGORY_LABEL = Object.fromEntries(
  INTERNAL_EXPENSE_CATEGORY_OPTIONS.map(({ label, value }) => [value, label])
) as Record<string, string>;
